import useSWRMutation from "swr/mutation";
import { ServicesURL } from "@utils/utilsApi";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { EditionKind } from "../../types";
import { buildEditionPayload } from "../../editionPayload";
import { SessionWizardEdition } from "./useSessionWizardSubmit";

export const useDeleteSession = (
  corporateId: string | number,
  editionId: string | number,
  kind: EditionKind,
) => {
  const { trigger, isMutating } = useSWRMutation(
    `${ServicesURL.getEditions}/${kind}/${editionId}?corporateId=${corporateId}`,
    (url: string, { arg }: { arg: any }) =>
      fetcher<any>(url, MethodType.PUT, arg),
  );

  const deleteSession = async (
    edition: SessionWizardEdition,
    existingSessions: any[],
    targetSessionId: string | number,
  ) => {
    const filtered = (existingSessions || []).filter(
      (s) => String(s?.id) !== String(targetSessionId),
    );

    const payload = buildEditionPayload(
      {
        lo_id: edition.lo_id ?? edition.learning_objects?.id,
        edition_code: edition.edition_code,
        edition_name: edition.edition_name,
        extra_info: edition.extra_info,
        publish_date: edition.publish_date,
      },
      filtered,
      kind,
    );

    await trigger(payload);
  };

  return { deleteSession, isDeleting: isMutating };
};
